import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { BLOGS } from "../../constants/constants";
import styles from "./BlogDetail.module.css";
import BannerHeader from "../../components/BannerHeader/BannerHeader";

const BlogDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const blog = BLOGS.find((b) => b.slug === slug);
  // Exclude current blog and get up to 3 most recent
  const recentBlogs = BLOGS.filter((b) => b.slug !== slug)
    .sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate))
    .slice(0, 2);

  if (!blog) {
    return <div className={styles.notFound}>Blog not found.</div>;
  }

  const blogStructuredData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: blog.title,
    image: blog.image,
    datePublished: blog.publishedDate,
    author: blog.author || "Green Rock Creations",
    description: blog.summary,
    url: `https://www.greenrockcreations.com/blog/${blog.slug}`,
  };

  return (
    <>
      <title>Green Rock Creations | {blog.title}</title>
      <meta name="description" content={blog.summary} />
      <meta property="og:title" content={blog.title} />
      <meta property="og:description" content={blog.summary} />
      <meta property="og:image" content={blog.image} />
      <meta property="og:type" content="article" />
      <meta
        property="og:url"
        content={`https://www.greenrockcreations.com/blog/${blog.slug}`}
      />
      <script type="application/ld+json">
        {JSON.stringify(blogStructuredData)}
      </script>
      <div className={styles.container}>
        <BannerHeader />
        <div className={styles.content}>
          <div className={styles.card}>
            <h1 className={styles.title}>{blog.title}</h1>
            <img src={blog.image} alt={blog.title} className={styles.image} />
            <div className={styles.metaInfo}>
              <span className={styles.date}>
                {new Date(blog.publishedDate).toLocaleDateString(undefined, {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </span>
              {blog.author && (
                <span className={styles.author}>By {blog.author}</span>
              )}
            </div>
            <div className={styles.htmlContent}>
              <div dangerouslySetInnerHTML={{ __html: blog.content }} />
            </div>
          </div>
          <div className={styles.sidebar}>
            {recentBlogs.map((b) => (
              <div
                key={b.id}
                className={styles.sidebarCard}
                onClick={() => navigate(`/blog/${b.slug}`)}
                tabIndex={0}
                role="button"
                aria-pressed="false"
              >
                <div className={styles.sidebarImageWrapper}>
                  <img
                    src={b.image}
                    alt={b.title}
                    className={styles.sidebarImage}
                  />
                </div>
                <div className={styles.sidebarContent}>
                  <div>
                    <h2 className={styles.sidebarTitleCard}>{b.title}</h2>
                    <p className={styles.sidebarSummary}>{b.summary}</p>
                  </div>
                  <div className={styles.sidebarDate}>
                    {new Date(b.publishedDate).toLocaleDateString(undefined, {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
